export default __webpack_public_path__ + "static/media/GT-Cinetype-Bold.9dd56089.eot";